import React from 'react';
import { motion } from 'framer-motion';
export function SystemIntro() {
  return <section className="w-full bg-white/75 px-5 py-14 sm:py-20" data-id="element-291" data-mp="1yi5c8mcypkfz">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-292" data-mp="1ygc8pfxnbgc7">
        <span className="mb-5 inline-block rounded-full border border-chem/30 bg-chem/10 px-4 py-1.5 text-[10px] font-semibold uppercase tracking-[0.12em] text-chem-deep sm:text-[11px]" data-id="element-293" data-mp="1bk262f5xky7f">
          Wszystko w jednym systemie
        </span>
        <h2 className="font-display text-2xl font-bold leading-tight text-ink sm:text-[42px]" data-id="element-294" data-mp="1phqrbo3wu7d0">
          Wszystko, czego potrzebujesz, aby uczyć chemii jaśniej i sprawniej.
        </h2>
        <p className="mt-5 text-base font-medium text-chem-deep sm:text-lg" data-id="element-295" data-mp="30wdunmm31bkh">
          Wizualna Chemia™ — Kompletny System Materiałów do Nauczania Chemii
        </p>
        <div className="mt-6 h-px w-16 bg-chem/40" data-id="element-296" data-mp="15gjckvd2uk7f" />
        <p className="mt-6 text-sm leading-relaxed text-ink/70 sm:text-base" data-id="element-297" data-mp="11i3k4by88jmm">
          Od budowy atomu po doświadczenia laboratoryjne: otrzymujesz uporządkowaną bibliotekę
          materiałów, która pomaga wyjaśniać abstrakcyjne zagadnienia za pomocą schematów, ćwiczeń i
          zastosowań.
        </p>
      </motion.div>
    </section>;
}